import * as React from 'react';
import { Film } from '../icons';
import { styled } from '@glitz/react';
import { softWhite } from 'webapp/shared/sharedTheme';

export const VideoPlaceholder = styled((props: React.ComponentPropsWithoutRef<'div'>) => {
  return (
    <IconWrapper {...props}>
      <FilmIcon />
    </IconWrapper>
  );
});

const FilmIcon = styled(Film, {
  width: '80%',
  height: '80%',
});

const IconWrapper = styled.div({
  backgroundColor: softWhite,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
